import { render } from "./index.vue?vue&type=template&id=ec472caa&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Matches/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec472caa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec472caa', __exports__)) {
    api.reload('ec472caa', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=ec472caa&ts=true", () => {
    api.rerender('ec472caa', render)
  })

}


export default __exports__